<template>
  <div ref="root"
       @click="onClick"
       :class="{
         '_disabled': !service.enabled,
         '_sub-items': service.childs && service.childs.length,
         '_open': isOpen,
         '_in-transition': inTransition
        }"
       :style="{marginBottom: marginBottom}"
       class="service-group-card">
    <div v-if="!service.enabled"
         class="service-group-card__label">
      {{ $tServices('Soon') }}
    </div>
    <!--    :style="`background-image: url('../assets/img/svg/services/tickets.svg')`"  -->
    <div :style="`background-image: url(${img})`"
         class="service-group-card__icon"></div>
    <h3 class="service-group-card__name">
      <router-link-modified v-if="service.enabled"
                            :to="route">
        {{ service.name }}
      </router-link-modified>
      <template v-else>
        {{ service.name }}
      </template>
    </h3>
    <div :style="{paddingTop: overlayHeight ? overlayHeight + 'px' : null}"
         class="service-group-card__overlay">
      <div v-if="service.childs && service.childs.length"
           class="service-group-card__list-wrap">
        <CollapseTransition @before-enter="onStartOpen"
                            @after-enter="afterOpen"
                            @after-leave="inTransition = false">
          <div v-show="isOpen"
               class="service-group-card__list">
            <template v-if="service.enabled">
              <router-link-modified v-for="(child, index) in service.childs"
                                    :key="child.slug + index"
                                    :to="formatClientLink(child.link) || {name: 'service', params: {id: service.slug, childId: child.slug}}"
                                    class="service-group-card__list-link  base-btn  base-btn--small  base-btn--outline-dark">
                {{ child.name }}
              </router-link-modified>
            </template>
            <template v-else>
              <div v-for="(child, index) in service.childs"
                   :key="child.slug + index"
                   style="pointer-events: none"
                   class="service-group-card__list-link  base-btn  base-btn--small  base-btn--outline-dark">
                {{ child.name }}
              </div>
            </template>
          </div>
        </CollapseTransition>
        <button v-if="isOpen"
                @click.prevent="onToggle"
                class="service-group-card__toggle base-btn  base-btn--small  base-btn--outline-dark">
          <span>{{ $tServices('Collapse') }}</span>
          <BaseSvg name="ico-arrow"/>
        </button>
        <button v-show="!isOpen"
                @click.prevent="onToggle"
                class="service-group-card__toggle base-btn  base-btn--small  base-btn--outline-dark">
          <span class="d-sm-none">{{ $tServices('Show services') }}</span>
          <span class="d-none  d-sm-inline">{{ $tServices('Services') }}</span>
          <BaseSvg name="ico-arrow"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'ServiceGroupCard',
    components: {
      CollapseTransition
    },
    props: {
      service: {
        type: Object,
        required: true
      },
      trigger: Number
    },
    data() {
      return {
        isOpen: false,
        overlayHeight: null,
        inTransition: false,
        listHeight: null
      }
    },
    computed: {
      ...mapState([
        'currentLocale',
        'defaultLocale',
      ]),
      img() {
        return this.service.enabled ? this.service.icon_enabled : this.service.icon_disabled
      },
      route() {
        return this.formatClientLink(this.service.link) || {name: 'service', params: {id: this.service.slug}}
      },
      marginBottom() {
        const el = this.$el && this.$el.closest('.services-page__services-item-wrap._wide-sm')
        const addHeight = el ? -14 : 48
        return this.isOpen && this.listHeight ? this.listHeight + addHeight + 14 + 'px' : null
      }
    },
    methods: {
      onClick(e) {
        if (
          !this.service.enabled
          || e.target.closest('.service-group-card__list, .service-group-card__toggle')
        ) {
          return
        }

        e.preventDefault()

        this.$router.push(this.route)
      },
      onToggle() {
        if (this.isOpen) {
          this.isOpen = false
        } else {
          this.$emit('open')
          setTimeout(() => {
            this.isOpen = true
          })
        }
      },
      onStartOpen(el) {
        this.inTransition = true
        setTimeout(() => {
          console.log(el.scrollHeight)
          this.listHeight = el.scrollHeight
        })
      },
      afterOpen(el) {
        setTimeout(() => {
          this.listHeight = el.scrollHeight
        })
      },
      setOverlayHeight() {
        this.overlayHeight = this.$refs.root.offsetHeight
      },
      runHeightChecker() {
        this.setOverlayHeight()

        window.addEventListener('resize', this.setOverlayHeight)
      },
      stopChecker() {
        window.removeEventListener('resize', this.setOverlayHeight)
      },
      formatClientLink(link) {
        if (!link) return null

        if (link.startsWith('http')) {
          return link
        }

        if (!link.startsWith('/')) {
          link = '/' + link
        }

        if (this.defaultLocale === this.currentLocale) {
          return link
        }

        return `/${this.currentLocale}${link}`
      }
    },
    mounted() {
      this.runHeightChecker()
    },
    beforeDestroy() {
      this.stopChecker()
    },
    watch: {
      trigger() {
        this.isOpen = false
      }
    }
  }
</script>

<style lang="less">

</style>
